// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-4c5f88e2]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.tip[data-v-4c5f88e2] {\n  margin-bottom: 20px;\n}\n.el-checkbox-group[data-v-4c5f88e2] {\n  margin-bottom: 50px;\n}", ""]);
// Exports
module.exports = exports;
